import React from 'react'

import DropDownMenu from 'components/CommonUI/Dropdown'
import {makeStyles} from '@material-ui/core/styles'

const useAreaStyles = makeStyles(() => {
    return {
        container: {
            width: '100%',
            position: 'relative',
            display: 'flex',
        },
        root: {
            borderRadius: '6px',
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: (props) =>
                props.styleType === 'light' ? 'rgba(21, 31, 49, 0.15)' : '#64686D',
            backgroundColor: (props) =>
                props.styleType === 'light' ? '#ffffff' : 'rgba(255, 255, 255, 0.15)',
            overflow: 'hidden',
            height: 140,
            '&.focus': {
                borderColor: '#4AA652 !important',
                boxShadow: '0px 4px 6px rgba(74, 166, 82, 0.16)',
            },
        },
        focused: {
            borderColor: '#4AA652 !important',
            boxShadow: '0px 4px 6px rgba(74, 166, 82, 0.16)',
        },
        error: {
            borderColor: '#D40C20 !important',
            boxShadow: '0px 4px 6px rgba(212, 12, 32, 0.16)',
        },
        disabled: {
            borderColor: 'rgba(21, 31, 49, 0.15) !important',
            backgroundColor: 'rgba(229, 229, 229, 1)',
        },
        input: {
            width: '240px',
            height: '50px !important',
            position: 'relative',
            fontSize: 16,
            letterSpacing: '0.016em',
            marginRight: '35px',
            color: '#151F31',
            '&::placeholder': {
                opacity: 1,
                color: (props) =>
                    props.styleType === 'light' ? 'rgba(21, 31, 49, 0.3)' : '#B0B0B0',
            },
            '&[disabled]': {
                opacity: 1,
                color: (props) => (props.styleType === 'light' ? '#838992' : '#B0B0B0'),
            },
        },
    }
})

const SelectForHelpSupport = ({ dataList = [], handleChange, selectedValue, emptyValue, label }) => {

    const inputClasses = useAreaStyles({  })

    return (
        <DropDownMenu
            label={label}
            emptyValue={emptyValue}
            classNameContainer={inputClasses.input}
            handleSelectedClick={handleChange}
            selectedValue={selectedValue || dataList[0]}
            styleMenu={{
                top: '75px',
                bottom: 'unset',
            }}
        >
            {dataList.map((item, index) => {
                return (
                    <DropDownMenu.Item key={item.id || index} itemData={item}>
                        <span className="help-support-item">{item.label}</span>
                    </DropDownMenu.Item>
                )
            })}
        </DropDownMenu>
    )
}


export default SelectForHelpSupport
